module.exports = __webpack_public_path__ + "img/icon.87d8253e.jpg";